import { render, staticRenderFns } from "./VesselHistory.vue?vue&type=template&id=3a677a18&scoped=true&"
import script from "./VesselHistory.vue?vue&type=script&lang=js&"
export * from "./VesselHistory.vue?vue&type=script&lang=js&"
import style0 from "./VesselHistory.vue?vue&type=style&index=0&id=3a677a18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a677a18",
  null
  
)

export default component.exports